module.exports = __webpack_public_path__ + "static/media/3.290023c5.svg";